// хэш страниц и позиции скролла
var scrollStateMap = {};
var getScrollTop = function () {
    if (document.documentElement && document.documentElement.scrollTop) {
        return document.documentElement.scrollTop;
    }
    if (document.body) {
        return document.body.scrollTop;
    }
    return 0;
};
var setScrollTop = function (value) {
    if (document.documentElement && document.body) {
        // eslint-disable-next-line no-multi-assign
        document.documentElement.scrollTop = document.body.scrollTop = value;
    }
};
var generateScrollStateKey = function (route) {
    return route.name + JSON.stringify(route.params);
};
var isIgnoreScrollRestore = function (route) {
    return (route &&
        route.meta &&
        route.meta.options &&
        route.meta.options.ignoreScrollRestore);
};
var isSameRoute = function (toState, fromState) {
    return toState && fromState && toState.name === fromState.name;
};
var isReplace = function (route) {
    return Boolean(route && route.meta && route.meta.options && route.meta.options.replace);
};
export var restoreScrollPosition = function () { return ({
    onTransitionStart: function (toState, fromState) {
        // Сохранение скрола предыдущей страницы в хэш, только если нет флага replace (замены текущего урла в истории)
        if (fromState && !isReplace(toState)) {
            scrollStateMap[generateScrollStateKey(fromState)] = getScrollTop();
        }
    },
    onTransitionSuccess: function (toState, fromState) {
        var canTryRestoreScroll = true;
        // Если есть флаг игнорирования восстановления скролла ignoreScrollRestore
        if (isIgnoreScrollRestore(toState)) {
            // Дополнительно проверяем флаг replace
            // и то что переход не с того же роута, как при скроле с дозагрузкой в гриде
            // для восстановления скролла при переходе из карточки товара обратно в грид
            if (isReplace(toState) && !isSameRoute(toState, fromState)) {
                canTryRestoreScroll = true;
            }
            else {
                canTryRestoreScroll = false;
            }
        }
        if (canTryRestoreScroll) {
            setTimeout(function () {
                if (toState &&
                    toState.name &&
                    scrollStateMap[generateScrollStateKey(toState)]) {
                    setScrollTop(scrollStateMap[generateScrollStateKey(toState)]);
                }
                else {
                    setScrollTop(0);
                }
            }, 1);
        }
    },
}); };
